import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

const F = ({ label, children }) => (
  <label className="flex flex-col gap-1.5">
    <span className="eyebrow text-[#6b6b6b] !text-[10px]">{label}</span>
    {children}
  </label>
);

export default function GuestForm({ guest, setGuest, consent, setConsent }) {
  const set = (k) => (e) => setGuest((g) => ({ ...g, [k]: e.target.value }));
  return (
    <div className="grid gap-4 sm:grid-cols-2" data-testid="guest-form">
      <div className="sm:col-span-2"><F label="Full name"><input className="field" required minLength={2} maxLength={80} autoComplete="name" value={guest.name} onChange={set("name")} data-testid="guest-name-input" /></F></div>
      <F label="Email"><input type="email" className="field" required autoComplete="email" value={guest.email} onChange={set("email")} data-testid="guest-email-input" /></F>
      <F label="Contact number"><input type="tel" className="field" required autoComplete="tel" placeholder="+91 98765 43210" pattern="\+?[0-9 \-]{8,16}" value={guest.phone} onChange={set("phone")} data-testid="guest-phone-input" /></F>
      <label className="sm:col-span-2 flex items-start gap-3 text-sm text-[#3b3b3b] mt-2">
        <input type="checkbox" className="mt-1 accent-[#1E3B2E] h-4 w-4" checked={consent} onChange={(e) => setConsent(e.target.checked)} data-testid="guest-consent-checkbox" />
        <span>I agree to the <Link to="/policies/terms" className="underline" target="_blank">Terms</Link>, <Link to="/policies/cancellation" className="underline" target="_blank">Cancellation</Link> and <Link to="/policies/privacy" className="underline" target="_blank">Privacy</Link> policies.</span>
      </label>
      <p className="sm:col-span-2 flex items-center gap-2 text-xs text-[#6b6b6b]"><Lock size={12} /> We only collect what is needed for your stay. Your details are never shared or sold.</p>
    </div>
  );
}
